import { render, staticRenderFns } from "./formPersionTeam.vue?vue&type=template&id=40fa68b8&scoped=true"
import script from "./formPersionTeam.vue?vue&type=script&lang=js"
export * from "./formPersionTeam.vue?vue&type=script&lang=js"
import style0 from "./formPersionTeam.vue?vue&type=style&index=0&id=40fa68b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fa68b8",
  null
  
)

export default component.exports